export const categories = [
  { slug: 'all', name: '全部攻略', icon: 'ri-gamepad-line', description: '浏览所有黄油游戏攻略内容' },
  { slug: 'beginner', name: '新手入门', icon: 'ri-lightbulb-line', description: '从零开始，快速上手黄油游戏' },
  { slug: 'character', name: '角色攻略', icon: 'ri-user-heart-line', description: '全角色解锁与养成攻略大全' },
  { slug: 'hidden', name: '隐藏内容', icon: 'ri-eye-off-line', description: '发现游戏中的隐藏关卡与彩蛋' },
  { slug: 'advanced', name: '进阶技巧', icon: 'ri-rocket-line', description: '高手玩家的独家进阶秘籍' },
  { slug: 'resource', name: '资源大全', icon: 'ri-stack-line', description: '道具获取、金币刷取等资源攻略' },
];

export const categoryMap: Record<string, { name: string; icon: string; description: string }> = {};
categories.forEach((c) => {
  categoryMap[c.slug] = { name: c.name, icon: c.icon, description: c.description };
});